/**
 * Whether a contact at `distance` km belongs to the group "less than `bucket`
 * km" that follows the group "less than `previousBucket` km" (0 for the first
 * group). The first group includes 0: the server rounds to 0.1 km, so a
 * contact at the same place as me arrives as exactly 0.
 */
export const isInDistanceBucket = (
  distance: number | null,
  previousBucket: number,
  bucket: number,
): boolean =>
  distance != null &&
  distance <= bucket &&
  (previousBucket === 0 ? distance >= 0 : distance > previousBucket)
